import React from "react";
import Header from "../../Sections/Header";
import Footer from "../../Sections/Footer";
import Price from "../../Sections/Price";
import NicheHero from "../../Components/NicheShared/NicheHero";
import NicheFeatures, { Feature } from "../../Components/NicheShared/NicheFeatures";
import NicheSteps from "../../Components/NicheShared/NicheSteps";
import NicheCTA from "../../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../../Components/RevealOnScroll";
import { NavLink } from "../../types/nav";

const LINKS: NavLink[] = [
  { label: "Início",          to: "/barbearia#hero" },
  { label: "Funcionalidades", to: "/barbearia#features" },
  { label: "Como funciona",   to: "/barbearia#steps" },
  { label: "Planos",          to: "/barbearia#price" },
];

const FEATURES: Feature[] = [
  {
    icon: "mdi:clock-outline",
    title: "Agendamento 24h",
    description: "Cliente marca mesmo fora do horário comercial, sem você precisar responder.",
  },
  {
    icon: "mdi:content-cut",
    title: "Cardápio de serviços",
    description: "Corte, barba, pacotes e preços apresentados direto no chat.",
  },
  {
    icon: "mdi:bell-outline",
    title: "Lembrete automático",
    description: "Menos falta, mais receita. Alfred confirma o horário antes do dia.",
  },
  {
    icon: "mdi:heart-outline",
    title: "Follow-up de fidelização",
    description: "Reengaja clientes que sumiram com mensagens automáticas.",
  },
];

const STEPS: string[] = [
  "Cadastre seus serviços e horários disponíveis",
  "Cliente agenda pelo WhatsApp sem precisar ligar",
  "Alfred confirma, lembra e mantém o cliente fiel",
];

const Barbearia: React.FC = () => (
  <>
    <Header links={LINKS} />
    <NicheHero
      id="hero"
      headline={`Sua barbearia sempre ocupada. <br/> O <span style="color:#E4DA1B;">Alfred</span> preenche a agenda 24h.`}
      subheadline="Do agendamento ao lembrete, o Alfred cuida do seu WhatsApp enquanto você cuida dos clientes."
    />
    <RevealOnScroll><NicheFeatures id="features" features={FEATURES} /></RevealOnScroll>
    <RevealOnScroll><NicheSteps id="steps" steps={STEPS} /></RevealOnScroll>
    <RevealOnScroll>
      <NicheFollowUp
        title="Clientes voltam mais quando alguém lembra deles."
        subtitle="O Alfred identifica quem está sumido e manda a mensagem certa, no momento certo."
        items={[
          "Reative clientes que não marcam faz semanas",
          "Envie promoções para sua base de clientes fiéis",
          "Acompanhe quem agendou e nunca apareceu",
        ]}
      />
    </RevealOnScroll>
    <RevealOnScroll><NicheCTA phrase="Cadeira ocupada, negócio crescendo." /></RevealOnScroll>
    <div id="price">
      <Price />
    </div>
    <Footer />
  </>
);

export default Barbearia;
